import { i18nMark } from 'lingui-react';

const formattedMessages = {
  engine: i18nMark('Engine'),
  make: i18nMark('Make'),
  model: i18nMark('Model'),
  noOpenCases: i18nMark('No Open Cases'),
  odometer: i18nMark('Odometer'),
  pmStatus: i18nMark('Maintenance'),
  serial: i18nMark('Serial'),
  title: i18nMark('Unit {unitNumber}'),
  unitNumber: i18nMark('Unit'),
  vin: i18nMark('VIN'),
  year: i18nMark('Year'),
};

export default formattedMessages;



// WEBPACK FOOTER //
// ./components/AssetDisplayElement/messages.js